<template>
  <!--<validation-observer ref="observer" v-slot="{ passes }">-->
  <div class="modal-card" style="width: auto">
    <header class="modal-card-head">
      <p class="modal-card-title">
        {{ titulo }}
      </p>
    </header>
    <div class="modal-card-body">
      <section>
        <b-field label="Tipo Entrega">
          <span class="has-text-weight-bold is-size-5">{{ model.nombre }}</span>
        </b-field>
        <div>
          <table class="table is-bordered is-narrow is-fullwidth">
            <thead>
              <tr>
                <th style="width: 30%">Tipo Pedido</th>
                <th style="width: 35%">
                  Tiempo asignaci&oacute;n Log&iacute;stica
                </th>
                <th style="width: 35%">Tiempo asignaci&oacute;n Bodega</th>
              </tr>
            </thead>
            <tbody v-if="tiemposAsignacion.length > 0">
              <tr
                v-for="(item, index) in tiemposAsignacion"
                :key="`tiempo-asignacion-${index}`"
                :class="{ 'modified-row': item.modificado }"
              >
                <td style="vertical-align: middle">
                  <span>
                    {{ tiemposAsignacion[index].tipoPedido.nombre }}
                  </span>
                </td>
                <td style="vertical-align: middle; text-align: center">
                  <b-numberinput
                    v-if="canModify"
                    v-model.number="tiemposAsignacion[index].tiempoLogistica"
                    :min="0"
                    @input="changeInputHandle('log', item)"
                  />
                  <span v-else>
                    {{ tiemposAsignacion[index].tiempoLogistica }}
                  </span>
                </td>
                <td style="vertical-align: middle; text-align: center">
                  <b-numberinput
                    v-if="!esMonitor"
                    v-model.number="tiemposAsignacion[index].tiempoBodega"
                    :min="tiemposAsignacion[index].tiempoLogistica"
                    @input="changeInputHandle('bod', item)"
                  />
                  <span v-else>
                    {{ tiemposAsignacion[index].tiempoBodega }}
                  </span>
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="3">
                  <span class="has-text-centered">
                    No hay registro configurados
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
      <b-loading v-model="loading" :is-full-page="false"></b-loading>
    </div>
    <footer class="modal-card-foot">
      <div class="buttons">
        <b-button
          v-if="!esMonitor"
          type="is-info"
          :disabled="!canSave && !canModify"
          :loading="loading"
          @click="submit"
        >
          <span>Guardar</span>
        </b-button>
        <button class="button" @click="cerrarForm">
          <span>Salir</span>
        </button>
      </div>
    </footer>
  </div>
</template>

<script>
import { tipoEntregaBodegaService } from '@/services'

export default {
  name: 'TiemposAsignacionForm',
  props: {
    titulo: {
      type: String,
      default: 'Agregar Registro'
    },
    modificacion: {
      type: Boolean,
      default: false
    },
    bodega: {
      type: Object,
      required: true
    },
    objeto: {
      type: Object,
      required: false,
      default: () => this.modeloInicial
    },
    esMonitor: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      model: this.modeloInicial(),
      loading: false,
      tiemposAsignacion: []
    }
  },
  computed: {
    postModel() {
      return Object.assign(this.model, { bodegaId: this.bodega.id })
    },
    debounceFix() {
      return 0
    },
    canSave() {
      return !this.loading && this.tiemposAsignacion.some((x) => x.modificado)
    },
    canModify() {
      const validRoles = [3, 6]
      return (
        this.bodega.roles.some((item) => validRoles.includes(item.id)) &&
        !this.esMonitor
      )
    }
  },
  created() {
    this.loadData()
  },
  mounted() {
    this.model = Object.assign(this.model, this.objeto)
  },
  methods: {
    changeInputHandle(campo, objeto) {
      this.tiemposAsignacion = this.tiemposAsignacion.map((item) => {
        if (
          item.bodegaId === objeto.bodegaId &&
          item.tipoEntregaId === objeto.tipoEntregaId &&
          item.tipoPedido.id === objeto.tipoPedido.id
        ) {
          if (campo === 'log' && item.tiempoBodega < item.tiempoLogistica) {
            item.tiempoBodega = item.tiempoLogistica
          }
          item.modificado = true
        }
        return item
      })
    },
    async submit() {
      const self = this
      self.loading = true
      const modificados = self.tiemposAsignacion
        .filter((item) => item.modificado)
        .map((item) => {
          const current = { ...item }
          current.tipoPedido = item.tipoPedido.id
          return current
        })
      if (modificados.length > 0) {
        try {
          await tipoEntregaBodegaService.updateAsignacionByTiposEntregaAndBodega(
            self.bodega.id,
            self.objeto.id,
            modificados
          )
          self.notificarAccionCompletada(
            'Se actualizaron los tiempos de asignación por tipo de entrega correctamente'
          )
          self.$emit('close', true)
        } catch (error) {
          self.procesarError(error)
        }
      }
      self.loading = false
    },
    async loadData() {
      const self = this
      self.loading = true
      try {
        const rs =
          await tipoEntregaBodegaService.getTiposEntregaAsignacionByBodega(
            self.bodega.id,
            self.objeto.id
          )
        this.tiemposAsignacion = rs.data.map((item) =>
          Object.assign({}, item, {
            modificado: false
          })
        )
      } catch (error) {
        self.procesarError(error)
      }
      self.loading = false
    },
    cerrarForm() {
      this.loading = false
      this.$emit('close', false)
    },
    resetForm() {
      this.model = this.modeloInicial
      requestAnimationFrame(() => {
        this.$refs.observer.reset()
      })
    },
    modeloInicial() {
      return {
        id: null,
        nombre: null,
        tipoAsignacion: null,
        mostrarSinFacturar: false,
        puedePausar: false,
        tieneEntregaPosterior: false,
        usaSemaforo: false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.modified-row {
  background-color: #e6f1f9;
}
</style>
